import {
  DocumentsLegalFormData,
  DocumentsLegalFormLegalStatus,
} from '../hooks/useDocumentsLegalForm'

export const getDocumentsLegalStatus = (
  documents: DocumentsLegalFormData[],
): DocumentsLegalFormLegalStatus[] =>
  documents.map(d => d.legal_status_list).filter(legalStatus => legalStatus)

export const getDoclumentsByStatusId = (
  documents: DocumentsLegalFormData[],
  statusId: number,
): DocumentsLegalFormData | undefined =>
  documents.find(d => d.legal_status_list.id === statusId)

export const getDocumentDownloadUrl = (documentName: string): string => {
  return `/documents/${documentName}`
}
